import { Location, BranchLocation, LeafLocation } from '../types';

export function isBranch(node: Location): node is BranchLocation {
  return (
    Boolean(node) &&
    'children' in node &&
    Array.isArray((node as BranchLocation).children)
  );
}

export function isLeaf(node: Location): node is LeafLocation {
  return !isBranch(node);
}
